// extracted by mini-css-extract-plugin
export default {"timerAnimation":"Timer_timerAnimation__yXGJz","timeText":"Timer_timeText__anvO3"};